var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-div"},[_c('div',{staticClass:"logo-text"},[(!_vm.hideLogo)?_c('img',{attrs:{"src":require("../../assets/kayi-logo.png")}}):_vm._e(),_vm._v(" "),_c('div',[_vm._v("欢迎来到")]),_vm._v(" "),_c('div',[(!_vm.hideLogo)?_c('span',[_vm._v("卡易")]):_vm._e(),_vm._v("即时通讯系统")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c91cef3c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./packages/chat/src/welcome.vue
// module id = null
// module chunks = 